import { jsx as d } from "react/jsx-runtime";
import p from "react";
import { _ } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import '../../index51.css';const b = "_raw-button_1p3om_1", w = "_focused_1p3om_13", e = {
  rawButton: b,
  focused: w
};
function y(s) {
  const {
    children: n,
    className: a,
    disabled: c,
    elementRef: r,
    name: o,
    onClick: t,
    focused: u,
    type: f = "button",
    ...i
  } = s, l = p.useCallback(
    (m) => {
      t && t(o, m);
    },
    [t, o]
  );
  return /* @__PURE__ */ d(
    "button",
    {
      ref: r,
      name: typeof o == "string" ? o : void 0,
      type: f,
      className: _(
        e.rawButton,
        u && e.focused,
        a
      ),
      disabled: c,
      onClick: t ? l : void 0,
      ...i,
      children: n
    }
  );
}
export {
  y as default
};
